import request from '@/utils/request'
// import qs from 'qs'

// 资质列表
export const quaList = (getData) => {
  return request({
    url: '/web/qualificationses/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 详情
export const getId = (getData) => {
  return request({
    url: '/web/qualificationses/getId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除
export const deleteQua = (getData) => {
  return request({
    url: '/web/qualificationses/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改
export const updateQua = (postData) => {
  return request({
    url: '/web/qualificationses/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增
export const addQua = (postData) => {
  return request({
    url: '/web/qualificationses/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
